export function getDemetraPaymentMethodPresentation(method) {
    const paymentMethod = method || {};
    const type = typeof paymentMethod.type === 'string' ? paymentMethod.type.toUpperCase() : 'UNKNOWN';

    if (type === 'PAYPAL') {
        const email = hasText(paymentMethod.maskedCustomerEmail) ? paymentMethod.maskedCustomerEmail.trim() : null;
        return {
            title: 'PayPal',
            reference: email ? `Account ${email}` : 'Account PayPal',
            kind: 'paypal',
            logoClass: 'logoPaypal'
        };
    }

    if (type === 'CARD') {
        const brand = hasText(paymentMethod.brand) ? paymentMethod.brand.trim() : null;
        const cardNumber = hasText(paymentMethod.maskedCardNumber)
            ? paymentMethod.maskedCardNumber.trim()
            : (hasText(paymentMethod.lastFour) ? `**** ${paymentMethod.lastFour.trim()}` : null);
        const expiration = paymentMethod.expirationMonth || paymentMethod.expirationYear
            ? `Scadenza ${paymentMethod.expirationMonth || '--'}/${paymentMethod.expirationYear || '----'}`
            : null;
        return {
            title: ['Carta', brand, cardNumber].filter(Boolean).join(' '),
            reference: expiration,
            kind: 'card',
            logoClass: getCardLogoClass(brand)
        };
    }

    return {
        title: 'Metodo di pagamento',
        reference: null,
        kind: 'other',
        logoClass: null
    };
}

function hasText(value) {
    return typeof value === 'string' && value.trim().length > 0;
}

function getCardLogoClass(brand) {
    if (!brand) return null;
    const normalizedBrand = brand.toUpperCase();
    if (normalizedBrand.includes('VISA')) return 'logoVisa';
    if (normalizedBrand.includes('MASTERCARD') || normalizedBrand.includes('MASTER CARD')) return 'logoMastercard';
    if (normalizedBrand.includes('AMERICAN EXPRESS') || normalizedBrand.includes('AMEX')) return 'logoAmericanExpress';
    return null;
}
